import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Button,
  Chip,
} from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarIcon } from "../../../assets/Images/CalendarIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

const LeadFilterBody = ({ leadFilterObj }) => {
  const { filterState, setFilterState } = leadFilterObj;
  const [tagInput, setTagInput] = useState("");

  const handleChange = (e) => {
    setFilterState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDateChange = (key, subKey, date) => {
    setFilterState((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [subKey]: date
          ? moment(date)
              .utc()
              .format(
                subKey === "from"
                  ? "YYYY-MM-DDT00:00:00[Z]"
                  : "YYYY-MM-DDT23:59:59[Z]"
              )
          : "",
      },
    }));
  };

  const handleAddTag = () => {
    if (tagInput?.trim() === "") return;
    setFilterState((prev) => ({
      ...prev,
      tags: [...prev?.tags, tagInput.trim()],
    }));
    setTagInput("");
  };

  const handleRemoveTag = (tagToRemove) => {
    setFilterState((prev) => ({
      ...prev,
      tags: prev?.tags?.filter((tag) => tag !== tagToRemove),
    }));
  };

  const formatLabel = (str) =>
    str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

  return (
    <Box className="flex-column" gap={2}>
      {Object.entries(filterState)?.map(([key, value]: any) => {
        if (key === "tags") {
          return (
            <Box key={key}>
              <Typography className="font-14-grey mb-1">Tags</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <TextField
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  fullWidth
                  placeholder="Enter tag"
                  sx={commonStyles.inputField}
                />
                <Button
                  disabled={!tagInput.trim()}
                  color="primary"
                  variant="contained"
                  onClick={handleAddTag}
                  sx={{ minWidth: "40px", padding: "6px" }}
                >
                  <AddIcon />
                </Button>
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {filterState?.tags?.map((tag, idx) => (
                  <Chip
                    key={idx}
                    label={tag}
                    onDelete={() => handleRemoveTag(tag)}
                    deleteIcon={<CloseIcon fontSize="small" />}
                    sx={{
                      backgroundColor: "#e0e0e0",
                      color: "#333",
                      fontSize: "13px",
                      height: "22px",
                    }}
                  />
                ))}
              </Box>
            </Box>
          );
        }

        if (typeof value === "string") {
          return (
            <Box key={key}>
              <Box className="flex-align-center mb-1" gap={0.5}>
                <Typography className="font-14-grey">
                  {formatLabel(key)}
                </Typography>
                {key === "surgeoryDate" && (
                  <Typography className="font-14-lightgrey">
                    (YYYY-MM-DD)
                  </Typography>
                )}
              </Box>
              <TextField
                name={key}
                value={value}
                onChange={handleChange}
                variant="outlined"
                fullWidth
                placeholder={`Enter ${formatLabel(key)}`}
                sx={commonStyles.inputField}
              />
            </Box>
          );
        }

        if (
          typeof value === "object" &&
          value?.from !== undefined &&
          value?.to !== undefined
        ) {
          return (
            <Box key={key}>
              <Typography className="font-14-grey mb-1">
                {formatLabel(key)}
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  className="new-date-picker"
                  sx={{ position: "relative", padding: "6px" }}
                >
                  <DatePicker
                    selected={value.from ? moment(value.from).toDate() : null}
                    onChange={(date) => handleDateChange(key, "from", date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="From date"
                    isClearable
                    className="custom-date-input"
                  />
                  <span className="calendar-icon datepicker-icon">
                    <CalendarIcon />
                  </span>
                </Box>
                <Box
                  className="new-date-picker"
                  sx={{ position: "relative", padding: "6px" }}
                >
                  <DatePicker
                    selected={value?.to ? moment(value.to).toDate() : null}
                    onChange={(date) => handleDateChange(key, "to", date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="To date"
                    isClearable
                    className="custom-date-input"
                  />
                  <span className="calendar-icon datepicker-icon">
                    <CalendarIcon />
                  </span>
                </Box>
              </Box>
            </Box>
          );
        }

        return null;
      })}
    </Box>
  );
};

export default LeadFilterBody;
